import { render, staticRenderFns } from "./SearchSummary.vue?vue&type=template&id=671d9bd4"
import script from "./SearchSummary.vue?vue&type=script&lang=js"
export * from "./SearchSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Slash: require('/vercel/path0/components/common/Slash.vue').default,Search: require('/vercel/path0/components/partials/Search.vue').default,Button: require('/vercel/path0/components/common/Button.vue').default})
